import { FC } from 'react';
import {
  Box,
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
} from '@chakra-ui/react';
import {
  Control,
  FormState,
  UseFormGetValues,
  UseFormRegister,
} from 'react-hook-form';

import type { Condition } from 'types/notification';
import type { NotificationFormFields } from 'page/NotificationPage/types/notificationFormField';
import {
  ConditionForm,
  DateRangeForm,
  LevelForm,
  MessageForm,
  TitleForm,
} from 'page/NotificationPage/components/Forms';
import { CustomerList } from '../CustomerList';

type Props = {
  control: Control<NotificationFormFields>;
  formState: FormState<NotificationFormFields>;
  isOpen: boolean;
  shouldShowCostomerList: boolean;
  isButtonDisabled: boolean;
  register: UseFormRegister<NotificationFormFields>;
  getValues: UseFormGetValues<NotificationFormFields>;
  handleClose: () => void;
  handleChangeCondition: (condition: Condition) => void;
  handleClickGoDelete: () => void;
  handleClickGoConfirmation: () => void;
};

export const InputModalView: FC<Props> = ({
  control,
  formState,
  isOpen,
  shouldShowCostomerList,
  isButtonDisabled,
  register,
  getValues,
  handleClose,
  handleChangeCondition,
  handleClickGoDelete,
  handleClickGoConfirmation,
}) => (
  <Modal
    isOpen={isOpen}
    onClose={handleClose}
    size="6xl"
    blockScrollOnMount
    closeOnOverlayClick={false}
    closeOnEsc={false}
  >
    <ModalOverlay />
    <ModalContent h="90vh">
      <ModalHeader p="40px 40px 0 40px">お知らせ更新</ModalHeader>
      <ModalCloseButton />
      <ModalBody overflowY="auto" p="0 40px 0 40px">
        {/* 件名 */}
        <Box mt="40px">
          <TitleForm register={register} error={formState.errors.title} />
        </Box>
        {/* 本文 */}
        <Box mt="40px">
          <MessageForm register={register} error={formState.errors.message} />
        </Box>
        {/* お知らせ種別 */}
        <Box mt="40px">
          <LevelForm register={register} />
        </Box>
        {/* 表示期間 */}
        <Box mt="40px">
          <DateRangeForm
            control={control}
            getValues={getValues}
            startDateError={formState.errors.startDate}
            endDateError={formState.errors.endDate}
          />
        </Box>
        {/* 配信対象顧客 */}
        <Box mt="40px">
          <ConditionForm
            control={control}
            handleChangeCondition={handleChangeCondition}
          />
        </Box>
        {/* 顧客一覧 */}
        <Box mt="40px" mb="40px">
          {shouldShowCostomerList && <CustomerList />}
        </Box>
      </ModalBody>
      <ModalFooter justifyContent="center" p="40px">
        <Stack alignItems="center" spacing="24px">
          <Button
            w="140px"
            colorScheme="blackAlpha"
            onClick={handleClickGoConfirmation}
            isDisabled={isButtonDisabled}
          >
            確認
          </Button>
          <Button
            variant="link"
            colorScheme="blackAlpha"
            onClick={handleClickGoDelete}
          >
            このお知らせを削除
          </Button>
        </Stack>
      </ModalFooter>
    </ModalContent>
  </Modal>
);
